// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.session.ActivationConfiguration
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { ActivationState } from "abweb/dto/generated/session/ActivationState";
import { DeserializeContext } from "abweb/utils/json/DeserializeContext";
import { TSOGUtils } from "abweb/utils/json/TSOGUtils";
export class ActivationConfiguration {
  static createActivationConfiguration(activationDelay, activationState, activationTimeout) {
    const retVal = new ActivationConfiguration();
    retVal.initActivationConfiguration(activationDelay, activationState, activationTimeout);
    return retVal;
  }

  /** Do NOT invoke directly, instead use strongly typed createActivationConfiguration factory method */
  constructor() {}

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawads.ActivationConfiguration";
  }
  initFromJson(json, deserializeContext) {
    this.initActivationConfiguration(json.activationDelay, TSOGUtils.decodeObject(json.activationState, ActivationState, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "activationState")), json.activationTimeout);
  }
  initActivationConfiguration(activationDelay, activationState, activationTimeout) {
    this._activationDelay = activationDelay;
    this._activationState = activationState;
    this._activationTimeout = activationTimeout;
  }
  toTSOG(result, serializeContext) {
    const retVal = result;
    retVal["activationDelay"] = this._activationDelay;
    retVal["activationState"] = TSOGUtils.toTSOGNativeObject(this._activationState, serializeContext);
    retVal["activationTimeout"] = this._activationTimeout;
    return retVal;
  }
  get activationDelay() {
    return this._activationDelay;
  }
  set activationDelay(value) {
    this._activationDelay = value;
  }
  get activationState() {
    return this._activationState;
  }
  set activationState(value) {
    this._activationState = value;
  }
  get activationTimeout() {
    return this._activationTimeout;
  }
  set activationTimeout(value) {
    this._activationTimeout = value;
  }
}
//# sourceMappingURL=ActivationConfiguration.js.map
